<template>
  <v-scroll-y-transition mode="out-in">
    <div v-if="!user" class="text-h6 grey--text text--lighten-1 font-weight-light" style="align-self: center;">
      Выберите пользователя
    </div>
    <v-card v-else :key="user.EMP_ID" class="pt-6" flat max-width="100%" outlined>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td rowspan="3">
                  <v-img
                    lazy-src="/static/images/user.png"
                    :src="getUserAvatar()"
                    class="mb-6 justify-center"
                    width="100" height="100"
                  ></v-img>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="text-h5 mb-2">
                    {{ user.EMP_LAST_NAME }} {{ user.EMP_NAME }} {{ user.EMP_SNAME }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <positionChip :position="{ IPOS_ID: user.IPOS_ID, IPOS_NAME: user.EMP_WTITLE }" :mode="mode" @onPositionAdded="onPositionAdded" @onPositionSelected="onPositionSelected"/>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <contactsLine :user="user" :mode="mode" @onContactSelected="exploreContact"/>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- <userContactsCard :user="user" /> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-row class="text-left" tag="v-card-text" dense>
        <v-col class="text-right mr-4" tag="strong" cols="5">
          Подразделение:
        </v-col>
        <v-col cols="5">
          {{ user.ITP_MNEMO }}
        </v-col>
        <v-col class="text-right mr-4" tag="strong" cols="5">
          Пол:
        </v-col>
        <v-col cols="5">
          <sexChip :user="user" :mode="mode" @onSexChanged="onSexChanged"/>
        </v-col>
        <v-col class="text-right mr-4" tag="strong" cols="5">
          Пользователь ЛК:
        </v-col>
        <v-col cols="5">
          <poChip :user="user" :mode="mode" @onUserCreate="onUserCreate"/>
        </v-col>
        <v-col class="text-right mr-4" tag="strong" cols="5">
          Руководитель:
        </v-col>
        <v-col cols="5">
          <user-boss-list
            :user="user"
            :mode="mode"
            @onUserBossListUpdate="doUpdateBossList"
            @onUserBossDelete="doBossDelete"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-scroll-y-transition>
</template>

<script>
import { ORG_DEL_EMPLOEE_BOSS, ORG_UPD_EMPLOEE } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'
import positionChip from '@/components/modules/org/structure/staff/positionChip.vue'
import sexChip from '@/components/modules/org/structure/staff/sexChip.vue'
import poChip from '@/components/modules/org/structure/staff/poUserChip.vue'
import contactsLine from '@/components/modules/org/structure/staff/userContactsLine.vue'
import UserBossList from '@/components/modules/org/structure/staff/components/userBossList'

export default {
  name: 'orgUserCard',
  props: ['mode', 'user'],
  data: () => ({
    newPosID: null,
    newSexID: null,
    newBossList: []
  }),
  components: {
    UserBossList,
    positionChip,
    sexChip,
    poChip,
    contactsLine
  },
  computed: {
    currentDivision: {
      get: function () {
        return this.$store.getters.getCurrentDiv
      }
    }
  },
  methods: {
    exploreContact (contact) {
      console.log('Contact selected', contact)
      if (contact.CONT_TYPE === '0') {
        window.open('mailto:' + contact.CONT_VALUE)
      }
    },
    getUserAvatar () {
      let result = '/api/user/getPhoto.php?EMP_ID=' + this.user.EMP_ID
      if (this.user.INST_ID) {
        result = result + '&INST_UUID=' + this.user.INST_UUID
      }
      return result
    },
    clearForm () {
    },
    onPositionAdded (data) {
      this.$emit('onPositionAdded', data)
    },
    onPositionSelected (data) {
      this.$emit('onPositionSelected', data)
      this.newPosID = data
      this.newSexID = this.user.EMP_SEX
      this.newBossList = this.user.BOSSLIST
      this.onSaveEvent()
    },
    onSexChanged (data) {
      this.$emit('onSexChanged', data)
      this.newSexID = data
      this.newPosID = this.user.IPOS_ID
      this.newBossList = this.user.BOSSLIST
      this.onSaveEvent()
    },
    onUserCreate (data) {
      console.log('User created')
      this.$emit('onUserCreate', data)
    },
    doUpdateBossList (data) {
      console.log('BossList updated ', data)
      this.newSexID = this.user.EMP_SEX
      this.newPosID = this.user.IPOS_ID
      this.newBossList = data
      this.onSaveEvent()
    },
    doBossDelete (data) {
      console.log('Boss deleted ', data)
      const payload = {
        EMP_UUID: this.user.EMP_UUID,
        BOSS_UUID: data.EMP_UUID
      }
      this.$store.dispatch(ORG_DEL_EMPLOEE_BOSS, payload)
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка обработки данных' + err })
          console.log('Ошибка ', err)
        })
    },
    onSaveEvent () {
      // Сохраняем данные
      const payload = {
        EMP_LAST_NAME: this.user.EMP_LAST_NAME,
        EMP_NAME: this.user.EMP_NAME,
        EMP_SNAME: this.user.EMP_SNAME,
        EMP_ID: this.user.EMP_ID,
        EMP_SORT_NUM: this.user.EMP_SORT_NUM,
        EMP_SEX: this.newSexID,
        IPOS_ID: this.newPosID,
        INST_UUID: this.user.INST_UUID,
        BOSSLIST: this.newBossList
      }
      console.log('Saving user: ', payload)
      this.$store.dispatch(ORG_UPD_EMPLOEE, payload)
        .then((resp) => {
          this.$emit('onUserUpdate', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка сохранения данных' + err })
          console.log('Ошибка ', err)
        })
        .finally(() => {
          this.newPosID = null
          this.newSexID = null
        })
    }
  }
}
</script>
